module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David M. Gustafson, Robert E. Coleman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("David M. Gustafson")]), _vm._v(" is chair of the mission and evangelism department at Trinity Evangelical Divinity School in Deerfield, Illinois. He is an affiliate docent at Johannelund School of Theology in Uppsala, Sweden, and a fellow of the Billy Graham Center of Evangelism in Wheaton, Illinois. He is also the author of "), _c('I', [_vm._v("Gospel Witness: Evangelism in Word and Deed.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/MAygcg/images/cover.jpg?1685204507433",
      "alt": "This image is the cover for the book Gospel Witness"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Gospel Witness\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In light of our increasingly post-Christian Western contexts, David Gustafson offers a mission-oriented ecclesiology that moves from missional theory to practices of missional engagement. Introducing “God’s human drama” as a way to explain the gospel within God’s redemptive story, he outlines specific ways for pastors and church leaders to shape a “gospeling” culture within their congregations. Gustafson expertly lays the foundations of and approaches to evangelism that are seminal and apt for the church today.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0